module.exports = __webpack_public_path__ + "img/item8.0d6c55f3.png";